import { either, isEmpty, isNil } from "ramda";

const isEmptyValue = either(isNil, isEmpty);

const fetchCart = (key) => {
  let data = [];
  try {
    data = localStorage.getItem(key) || JSON.stringify([]);
    data = JSON.parse(data);
  } catch (error) {
    console.log({ error });
    return [];
  }

  return data;
};

const addToCart = (key, object, entityId) => {
  try {
    const currentData = localStorage.getItem(key) || JSON.stringify([]);
    let parsedData = JSON.parse(currentData);
    const data = { ...object, entityId };
    parsedData.push(data);

    // Delete duplicates from localstorage
    parsedData = parsedData.filter(
      (v, i, element) => element.findIndex((v2) => v2.id === v.id) === i,
    );
    localStorage.setItem(key, JSON.stringify(parsedData));
  } catch (error) {
    console.log({ error });
  }
};

const addAmountToCart = (key, id, amount) => {
  if (isEmptyValue(amount)) {
    return;
  }
  try {
    const currentData = localStorage.getItem(key) || JSON.stringify([]);
    const parsedData = JSON.parse(currentData);
    const index = parsedData.findIndex((obj) => obj.id == id);

    if (index >= 0) {
      parsedData[index].amount = amount;
      localStorage.setItem(key, JSON.stringify(parsedData));
    }
  } catch (error) {
    console.log({ error });
  }
};

const removeFromCart = (key, id) => {
  try {
    const currentData = localStorage.getItem(key) || JSON.stringify([]);
    let parsedData = JSON.parse(currentData);

    // Delete duplicates from localstorage
    parsedData = parsedData.filter((element) => element.id !== id);
    localStorage.setItem(key, JSON.stringify(parsedData));
  } catch (error) {
    console.log({ error });
  }
};

const clearCart = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.log({ error });
  }
};

export { addToCart, addAmountToCart, clearCart, fetchCart, removeFromCart };
